export enum GenderType {
  FEMALE = "FEMALE",
  MALE = "MALE",
}
